import client from "./Client";

// const baseUrl = "https://www.ndbc.noaa.gov/data/";

// export const getSwells = async () => {
//   const realtimeUrl = baseUrl + "realtime2/46053.spec";
//   let res = await axios.get(realtimeUrl);
//   let data = res.data;
//   console.log(data);
// };

export const getSwells = async (stationId = 46053) => {
  const { data } = await client.get(`/api/v1/ndbc/${stationId}/`);
  return data;
};
